import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import Conversiones from "../../../../utils/conversiones";
import { GrabarOperacionEndoso } from "../models/grabarOperacionEndoso";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";
import { ResultFechaRemesa, ResultOperacionEndoso } from "../models/resultOperacionEndoso";
import { RowEndosoMasivo } from "../models/rowEndosoMasivo";

const buscarEndososEnCartera = async (fechaEndoso: Date, inversionista: string) => {
    const formatFecha : string = Conversiones.formatDateReverse(fechaEndoso, "-");
    const response: Promise<AxiosResponse<ListResponseDto<RowEndosoMasivo>>> = axiosInstance.get(`siscred-api-cartera-total/v1/endosos/filtrar?fechaEndoso=${formatFecha}&rutInversionista=${inversionista}`);
    return response;
}

const grabarOperacion = async (grabarOperacionEndoso: GrabarOperacionEndoso) => {
    const response: Promise<AxiosResponse<ListResponseDto<ResultOperacionEndoso>>> = axiosInstance.post(`siscred-api-cartera-total/v1/endosos/grabar`, grabarOperacionEndoso);
    return response;
}

const fechaRemesar = async (idMutuo: number, numCuponCortado: number, rutInversionista: string, fechaEndoso: Date) => {

    const formatFecha : string = Conversiones.formatDateReverse(fechaEndoso, "-");

    const response: Promise<AxiosResponse<ResultFechaRemesa>> = axiosInstance.get(`siscred-api-cartera-total/v1/endosos/fecharemesar?idMutuo=${idMutuo}&numCuponCortado=${numCuponCortado}&rutInversionista=${rutInversionista}&fechaEndoso=${formatFecha}`);
    return response;
}
export {buscarEndososEnCartera, grabarOperacion, fechaRemesar}